// Ranked standings shared by the server and Discord leaderboards: the leader gets a card
// of their own, everyone else follows in a ranked list. Values arrive already formatted.
import type { ReactNode } from "react";
import { Icon } from "../icons";
import { RankBadge } from "./minecraft";

export type Standing = { key: string; rank: number; name: string; detail?: string | null; picture: ReactNode; leaderPicture: ReactNode; value: string };

export function Standings({ items, label, column, valueLabel, unit, noun }: { items: Standing[]; label: string; column: string; valueLabel: string; unit?: string; noun: string }) {
  const [leader, ...rest] = items;
  if (!leader) return null;
  return <div className="lb">
    <section className="lb-leader" aria-label="First place">
      <p className="lb-leader-place"><Icon name="trophy" size={16}/>First place</p>
      {leader.leaderPicture}
      <div className="lb-leader-name"><strong>{leader.name}</strong>{leader.detail && <small>{leader.detail}</small>}</div>
      <p className="lb-leader-value">{unit ? <><b>{leader.value}</b><span>{unit}</span></> : <><small>{valueLabel}</small><b>{leader.value}</b></>}</p>
    </section>
    <div className="lb-table">
      {rest.length > 0 && <div className="lb-head" aria-hidden="true"><span>Rank</span><span>{column}</span><span>{valueLabel}</span></div>}
      {rest.length ? <ol className="lb-rows" aria-label={label} start={2}>
        {rest.map((item) => <li key={item.key} className={`lb-row ${item.rank <= 3 ? `lb-top-${item.rank}` : ""}`}>
          <RankBadge rank={item.rank}/>
          <span className="lb-who">{item.picture}<span><strong>{item.name}</strong>{item.detail && <small>{item.detail}</small>}</span></span>
          <b className="lb-value">{item.value}</b>
        </li>)}
      </ol> : <p className="lb-alone">Only one {noun} has made this board so far. The next spot is open.</p>}
    </div>
  </div>;
}
